import axios from 'axios'
import { logger } from '@/app/shared/services/app-logger/app-logger';
import AuthService  from '@/app/shared/services/authentication/auth.service';

const apiBaseUrl = 'https://graph.microsoft.com/v1.0'
const config = {
  baseURL: apiBaseUrl
};


const axiosGraphApiInstance = axios.create(config);
const authService = new AuthService();

// Initialize MSAL for this auth service instance
const authInitPromise = authService.initialize();

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * @param {*} config
 */
const authInterceptor = async config => {
  if (config.baseURL === apiBaseUrl && !config.headers.Authorization) {
    await authInitPromise;
    const token = await authService.getMsGraphToken();
    config.headers.Authorization = `Bearer ${token.accessToken}`;
  }

  return config
};

axiosGraphApiInstance.interceptors.request.use(authInterceptor);

axiosGraphApiInstance.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (typeof error.response !== 'undefined') {
      const originalRequest = error.config;
      if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        await authInitPromise;
        const token = await authService.getMsGraphToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${token.accessToken}`;
        return axiosGraphApiInstance(originalRequest);
      }
    }

    logger.error(error);
    return Promise.reject(error);
  }
);

export { axiosGraphApiInstance };